import React from "react";
import styles from "./styles.css";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";
import { CmsContent } from "@cars24/turbo-web/lib/cms-content";
import Vector from "./images/Vector.svg";
import PropTypes from "prop-types";
import { seoClickChallan } from "./tracking";
import { sendCustomGaEvents } from "../../../tracking";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";

const EChallanCommonReasonsV2 = ({ whatIsChallanData, whyChallanIssueData }) => {

    const { title = "", description = "" } = whatIsChallanData || {};

    const { tokens } = useTokens();

    const { title: whyChallanTitle = "", whyChallanIssueList = [] } = whyChallanIssueData || {};

    const onViewChange = async (expanded) => {
        if (expanded) {
            await yieldToMain();
            sendCustomGaEvents(seoClickChallan);
        }
    };

    return (
        <>
            <div styleName={"styles.trafficEchallan"}>
                <Text size="450" fontWeight={"semibold"} as="h2" color={tokens.text_default_text_primary}>{title}</Text>
                <CmsContent
                    content={description}
                    isExpandable={(description || "").length > 0}
                    expandedText={"Read less"}
                    collapsedText={"Read more"}
                    lineCount={4}
                    onViewChange={onViewChange}
                    color={tokens.text_default_text_secondary}
                    suffixIcon={<img src={Vector} alt={"arrow"} />}
                    expandVariant="brand"
                />

            </div>
            <div styleName={"styles.trafficEchallanCardWrapper"}>
                <Text size="450" fontWeight="semibold" as="h2" color={tokens.text_default_text_primary}>{whyChallanTitle}</Text>
                <div styleName={"styles.trafficCardWrapper"}>
                    {
                        whyChallanIssueList.map((item, index) => (
                            <div styleName={"styles.trafficEchallanCard"} key={index}>
                                <img src={item?.image?.url} alt={item?.image?.alternativeText} />
                                <Text size="250" fontWeight="regular" color={tokens.text_default_text_secondary}>{item?.title}</Text>
                            </div>
                        ))}
                </div>
            </div>
        </>

    );
};

EChallanCommonReasonsV2.propTypes = {
    whatIsChallanData: PropTypes.object,
    whyChallanIssueData: PropTypes.object
};

export default EChallanCommonReasonsV2;
